export const INACTIVITY_THRESHOLD_MONTHS = 3;
